import { useContext } from "react";
import { SettingsContext } from "../components";

const useSettings = () => useContext(SettingsContext);

export { useSettings };
